import { useQuery } from '@tanstack/react-query'

import { ProjectsAPI } from '@makyoapp/makyo-sdk'
import { Order } from '@makyoapp/makyo-sdk/api/api'
import { ProjectFavorite, ProjectOrderBy, ProjectStatus } from '@makyoapp/makyo-sdk/models/Projects'
import { fromSdkAppList } from '@makyoapp/makyo-common'
import { projectPlanColor } from '@makyoapp/makyo-ui'

import { queryKeys } from '@/lib/react-query'
import { useCurrentOrgContext } from '@/context/CurrentOrgContext'

/**
 * Get Org's Apps (Project)
 */
export const useGetOrgApps = (opts?: {
  params: {
    teamID?: string
    search?: string
    favorite?: ProjectFavorite
    plan?: string
    status?: ProjectStatus | ''
  }
  enabled?: boolean
}) => {
  const { currentOrg } = useCurrentOrgContext()
  const orgID = currentOrg?.id

  const params = { ...opts?.params }

  return useQuery({
    queryKey: [queryKeys.orgApps, orgID, { ...params }],
    queryFn: () => {
      if (!orgID) return
      return ProjectsAPI.ReqList(
        params.teamID,
        params.search,
        Order.Desc,
        ProjectOrderBy.AccessedAt,
        params.favorite,
        params.plan,
        params.status,
        orgID
      ).then((apps) => fromSdkAppList(apps, projectPlanColor))
    },
    enabled: opts?.enabled ? !!orgID && opts.enabled : !!orgID,
    gcTime: 0,
    staleTime: 0,
  })
}
